var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AlaoButton',{attrs:{"size":"sm","full-width":"","is-loading":_vm.isLoading,"disabled":_vm.isLoading},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }